import styled from 'styled-components';

const PinInputContainer = styled.div``;

const getColor = ({ error, disabled, theme }) => {
  if (error) {
    return theme.colors.red[60];
  } else if (disabled) {
    return theme.colors.grey[50];
  } else {
    return theme.colors.grey[80];
  }
};

const DefaultInputStyle = styled.input<{ error: boolean; disabled: boolean }>`
  width: 40px;
  height: 40px;
  max-width: 40px;
  border-radius: 8px;
  border-style: solid;
  border-width: ${({ error }) => (error ? '1px' : '0')};
  border-color: ${({ error, theme }) =>
    error ? theme.colors.red[60] : 'transparent'};
  color: ${getColor};
  background-color: ${({ theme, error }) =>
    error ? 'transparent' : theme.colors.grey[10]};
  box-shadow: none;
  outline: none;
  text-align: center;
  user-select: none;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 24px;
  letter-spacing: normal;
  padding: 0;
  margin-right: 8px;
  box-sizing: border-box;

  &:last-of-type {
    margin-right: 0;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export { DefaultInputStyle, PinInputContainer };
